import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, MessagesApi } from '@shared/api';

interface UseMessagesFileStore {
  loading: boolean;
  error?: string | null;
  get: (messageId: string, filename: string) => void;
  clear: () => void;
}

export const useMessagesFileStore = create<UseMessagesFileStore>((set) => ({
  loading: false,
  error: null,

  get: async (messageId: string, filename: string) => {
    try {
      set({ loading: true, error: null });
      const blob = await MessagesApi.getMessageFile(messageId, filename);
      set({ loading: false });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { loading: false };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, error });
      return { loading: false, error };
    }
  },

  clear: () => set({ loading: false, error: null }),
}));
